import { render, staticRenderFns } from "./MemberRole.vue?vue&type=template&id=78aa84c5"
import script from "./MemberRole.vue?vue&type=script&lang=js"
export * from "./MemberRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports